import React from 'react';
import * as XLSX from 'xlsx';
import { BottomNavigationAction } from '@material-ui/core';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

function DebitExcelExport({ JsonData }) {
  if (JsonData?.length === 0) {
    return (
      <BottomNavigationAction
        disabled={true}
        showLabel
        label={'Excel Al'}
        icon={<CloudDownloadIcon />}
      />
    );
  }

  const handleExport = () => {
    const ExportData = JsonData.map((item) => ({
      FIS_NO: item.FIS_NO,
      MALZEME_STOK_NO: item.MALZEME_STOK_NO,
      MALZEME: item.MALZEME,
      DEPO_ADET: item.DEPO_ADET,
      ADRES_ADET: item.ADRES_ADET,
      MIKTAR: item.MIKTAR,
      ZIMMET_ADET: item.ZIMMET_ADET,
    }));

    // Başlıklar (label) ve veriler (value)
    const headers = [
      { label: 'FişNo', value: 'FIS_NO' },
      { label: 'MalzemeStokNo', value: 'MALZEME_STOK_NO' },
      { label: 'Malzeme', value: 'MALZEME' },
      { label: 'DepoAdet', value: 'DEPO_ADET' },
      { label: 'AdresAdet', value: 'ADRES_ADET' },
      { label: 'Miktar', value: 'MIKTAR' },
      { label: 'ZimmetAdet', value: 'ZIMMET_ADET' },
    ];

    // Başlıkları içeren bir array oluşturuyoruz
    const sheetData = [headers.map(header => header.label), ...ExportData.map(item => headers.map(header => item[header.value]))];

    // Excel dosyasını oluşturma
    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Envanter');

    // Excel dosyasını indirme
    XLSX.writeFile(workbook, 'Envanter.xlsx');
  };

  return (
    <BottomNavigationAction
      onClick={handleExport}
      showLabel
      label={'Excel'}
      icon={<CloudDownloadIcon />}
    />
  );
}

export default DebitExcelExport;
